<form [formGroup]="componentForm">
  <div class="big-calendar-wrapper">
    <div class="central-column">
      <div class="big-calendar-toolbar">
        <div class="picked-calendar-label">{{'Pick calendar' | GetLabelPipe}}</div>
        <mat-form-field appearance="fill" color="accent" class="big-calendar-picker">
          <mat-select matNativeControl formControlName="calendarPicker" [(value)]="selectedGroupCalendarIdx">
              <mat-option *ngFor="let groupCalendar of application.account.calendars; let i = index;"
                [value]="i">{{i+1}}. {{groupCalendar['settings']['name']}}</mat-option>
              <mat-option [value]="allCalendarsIdx">{{'Всі календарі'}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="spinner-container" *ngIf="!this.calendarDataLoaded">
          <mat-spinner color="accent" [diameter]="24"></mat-spinner>
        </div>
      </div>
      <div class="big-calendar-container" #calendarContainer>
        <full-calendar [options]='calendarOptions' #calendar></full-calendar>
      </div>
    </div>
    <div class="right-column divider-border-color background-global hidden-xs">
      <div class="date-picked-label-container">
        <div class="date-picked-label">{{selectedDate.getTime() | fsDate:true:true}}</div>
      </div>
      <mat-card class="inline-calendar-card">
        <mat-calendar [(selected)]="selectedDate"></mat-calendar>
      </mat-card>
    </div>
  </div>
</form>
